import { useCallback } from 'react';
import { useFormState, useField } from 'react-final-form';
var FIELD_SUBSCRIPTIONS = {
    dirty: true,
    modified: true,
    initial: true,
    error: true,
    touched: true,
    valid: true,
    visited: true,
    submitError: true,
    modifiedSinceLastSubmit: true,
    dirtySinceLastSubmit: true,
    value: true
};
export default function useFormField(props) {
    var name = props.name, type = props.type, validations = props.validations;
    var validate = useCallback(function (fieldValue) {
        if (validations) {
            // eslint-disable-next-line no-restricted-syntax
            for (var _i = 0, validations_1 = validations; _i < validations_1.length; _i++) {
                var validatorFn = validations_1[_i];
                var error = validatorFn(fieldValue);
                if (error)
                    return error;
            }
        }
        return '';
    }, [validations]);
    var field = useField(name, { validate: validate, type: type, subscription: FIELD_SUBSCRIPTIONS });
    var formState = useFormState();
    var fieldProps = {
        onChange: field.input.onChange,
        onBlur: field.input.onBlur,
        error: false,
        helperText: ''
    };
    /* only show error on field when touched */
    if (field.meta.touched && field.meta.error) {
        fieldProps.error = true;
        fieldProps.helperText = field.meta.error;
    }
    /* show error on submit regardless */
    if (field.meta.submitError && !field.meta.dirtySinceLastSubmit) {
        fieldProps.error = true;
        fieldProps.helperText = field.meta.submitError;
    }
    /*
      when errors are array of objects, it does not populate submitError
      this fixes that issue
    */
    if (typeof formState.submitErrors === 'object' &&
        name in formState.submitErrors &&
        !field.meta.modifiedSinceLastSubmit &&
        !field.meta.dirtySinceLastSubmit) {
        fieldProps.error = true;
        fieldProps.helperText = formState.submitErrors[name];
    }
    return { field: field, fieldProps: fieldProps };
}
